import React from 'react'
import ReactDOM from 'react-dom'
import { ThemeProvider } from 'styled-components'
import { positions, Provider as AlertProvider } from 'react-alert'
import AlertTemplate from 'react-alert-template-basic'
import { BrowserRouter } from 'react-router-dom'
import { Amplify } from 'aws-amplify'

import awsmobile from './main/configs/aws-exports'
import Routes from './main/routes'
import theme from './presentation/styles/theme'
import { GlobalStyle } from './presentation/styles'
import { addLanguage } from './main/adapters'
import {
  ModalBoxProvider,
  OnChangeDetectProvider,
  TestBlockProvider
} from './presentation/contexts'
import { Modal } from './presentation/components'

Amplify.configure(awsmobile)
addLanguage('pt_BR')

ReactDOM.render(
  <React.StrictMode>
    <AlertProvider
      className="no-print"
      template={AlertTemplate}
      position={positions.TOP_CENTER}
    >
      <OnChangeDetectProvider>
        <TestBlockProvider>
          <ModalBoxProvider>
            <BrowserRouter>
              <ThemeProvider theme={theme}>
                <GlobalStyle />
                <Routes />
                <Modal />
              </ThemeProvider>
            </BrowserRouter>
          </ModalBoxProvider>
        </TestBlockProvider>
      </OnChangeDetectProvider>
    </AlertProvider>
  </React.StrictMode>,
  document.getElementById('root')
)
